import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=56ac3079&scoped=true&"
import script from "./SearchFilters.vue?vue&type=script&lang=js&"
export * from "./SearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=56ac3079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac3079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ac3079')) {
      api.createRecord('56ac3079', component.options)
    } else {
      api.reload('56ac3079', component.options)
    }
    module.hot.accept("./SearchFilters.vue?vue&type=template&id=56ac3079&scoped=true&", function () {
      api.rerender('56ac3079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/SearchFilters.vue"
export default component.exports